import type { Edit } from '@w/crdt'
import type { CoreState } from './state'

const transactions = new WeakMap<object, Edit>()

export function beginOperation(state: CoreState, tx: Edit): void {
  transactions.set(state, tx)
}

export function transaction(state: CoreState): Edit {
  const tx = transactions.get(state)
  if (!tx) throw new Error('Mutation outside an operation')
  return tx
}


export function activeTransaction(owner: unknown): Edit | undefined {
  return owner && typeof owner === 'object' ? transactions.get(owner) : undefined
}